import { getLabelMessage } from '@gef-ui/localization/messages';

import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyAgent from 'app/forms/validations/isPolicyAgent';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import isSurname from 'app/forms/validations/isSurname';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const CAMPAIGN_MANAGEMENT_FORM_NAME = 'campaignManagement-filter';

const {
	channel,
	region,
	agency,
	manager,
	seller,
	ppz,
	policyNumber,
	product,
	firstName,
	surname,
	businessName,
	personIn,
	businessIn,
	municipality,
	zipCode,
} = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	channel,
	region,
	agency,
	manager,
	seller,
	ppz,
	policyNumber,
	policyEndDate: 'policyEndDate',
	product,
	contactState: 'contactState',
	assignLevel: 'assignLevel',
	firstName,
	surname,
	businessName,
	personIn,
	businessIn,
	municipality,
	zipCode,
	policyAgent: 'policyAgent',
	printType: 'printType',
};

export default () => ({
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [],
	},
	[FIELDS.manager]: {
		deepPath: [FIELDS.manager],
		validations: [],
	},
	[FIELDS.seller]: {
		deepPath: [FIELDS.seller],
		validations: [],
	},
	[FIELDS.ppz]: {
		deepPath: [FIELDS.ppz],
		validations: [],
	},
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
	[FIELDS.policyEndDate]: {
		deepPath: [FIELDS.policyEndDate],
		validations: [],
	},
	[FIELDS.product]: {
		deepPath: [FIELDS.product],
		validations: [],
	},
	[FIELDS.contactState]: {
		deepPath: [FIELDS.contactState],
		validations: [],
	},
	[FIELDS.assignLevel]: {
		deepPath: [FIELDS.assignLevel],
		validations: [],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [isBusinessName()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [isBirthNumber()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
	[FIELDS.policyAgent]: {
		deepPath: [FIELDS.policyAgent],
		validations: [isPolicyAgent()],
	},
	[FIELDS.printType]: {
		deepPath: [FIELDS.printType],
		validations: [],
	},
});
